// custom typefaces
require ("@fontsource/nunito-sans/400.css");
require ("@fontsource/nunito-sans/600.css");
// normalize CSS across browsers
require ("./src/normalize.css");
// custom CSS styles
require ("./src/bootstrap-custom.css");
require ("./src/style.css");

exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
  }) => {
    const currentPosition = getSavedScrollPosition(location);
    setTimeout(() => { window.scrollTo(...(currentPosition || [0, 0])); }, 100);
  
    return false;
  };
  